const Slider = new function() {
    let el;
    let slider;
    let sliderNav;

    this.init = () => {
        el = document.querySelector('#my-keen-slider');
        if (!el) return;

        slider = new KeenSlider(el, {
            breakpoints: {
                "(min-width: 601px)": {
                slides: {
                    perView: 1.5,
                    size: 1,
                    spacing: 25,
                },
                },
                "(min-width: 1001px)": {
                slides: {
                    perView: 2.5,
                    size: 1,
                    spacing: 30,
                },
                },
                "(min-width: 1260px)": {
                slides: {
                    perView: 3.2,
                    size: 1,
                    spacing: 35,
                },
                },
            },
            slides: {
                perView: 1.18,
                size: 1,
                spacing: 20,
            },
        });

        sliderNav = {
            prev: el.closest('.slider-wrapper').querySelector('.sn-slider-nav--prev'),
            next: el.closest('.slider-wrapper').querySelector('.sn-slider-nav--next'),
        };

        sliderNav.prev.addEventListener('click', slider.prev)
        sliderNav.next.addEventListener('click', slider.next)
    }
}

export default Slider;